import React, { useState, useEffect, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import Loading from "../Common/Loading";
import CustomAlert from "../Common/CustomAlert";
import popimg from "../Common/Images/ImagesForAlert/popup_bg1.png";
import popbg from "../Common/Images/ImagesForAlert/popup_bg2.png";
import popclose from "../Common/Images/ImagesForAlert/popup_close_n.png";
import bg from "../SYSADMIN/MathsDoctor/Images/top_blue_panel.png";
import AnsCorrect from "../SYSADMIN/MathsDoctor/Images/AnsCorrect.GIF";
import AnsShouldbe from "../SYSADMIN/MathsDoctor/Images/AnsShouldbe.GIF";
import AnsWrong from "../SYSADMIN/MathsDoctor/Images/AnsWrong.GIF";

import large_objective_n from "../SYSADMIN/MathsDoctor/Images/Tablet/large_objective_n.png";
import large_objective_d from "../SYSADMIN/MathsDoctor/Images/Tablet/large_objective_d.png";
import medium_objective_n from "../SYSADMIN/MathsDoctor/Images/Tablet/medium_objective_n.png";
import medium_objective_d from "../SYSADMIN/MathsDoctor/Images/Tablet/medium_objective_d.png";
import small_objective_n from "../SYSADMIN/MathsDoctor/Images/Tablet/small_objective_n.png";
import small_objective_d from "../SYSADMIN/MathsDoctor/Images/Tablet/small_objective_d.png";
import large_objective_shortened_n from "../SYSADMIN/MathsDoctor/Images/Tablet/large_objective_shortened_n.png";
import large_objective_shortened_d from "../SYSADMIN/MathsDoctor/Images/Tablet/large_objective_shortened_d.png";
import medium_objective_shortened_n from "../SYSADMIN/MathsDoctor/Images/Tablet/medium_objective_shortened_n.png";
import medium_objective_shortened_d from "../SYSADMIN/MathsDoctor/Images/Tablet/medium_objective_shortened_d.png";
import small_objective_shortened_n from "../SYSADMIN/MathsDoctor/Images/Tablet/small_objective_shortened_n.png";
import small_objective_shortened_d from "../SYSADMIN/MathsDoctor/Images/Tablet/small_objective_shortened_d.png";

const API_BASE_URL =
  process.env.REACT_APP_DOCUMENT_LINK || "https://staging.sysadmin.elearnoncloud.com/";

// ─── Interfaces ────────────────────────────────────────────────────────────────

interface HeaderInfo {
  SchoolCode: string;
  FamilyCode: string;
  Login: string;
  Name: string;
  Year: string;
  Score: string;
  TestDate: string;
  TimeTaken: string;
  MDCurriculum: string;
  Country: string;
}

interface SSTableRow {
  SlNo: number;
  Strand: string;
  SubStrand: string;
}

interface SSYTableRow {
  Chronology: number;
  Strand: string;
  SubStrand: string;
  Yr: string;
  Result: string;
}

interface QnTableRow {
  Chronology: number;
  Strand: string;
  SubStrand: string;
  Yr: string;
  Topic: string;
  QnNo: string;
  Result: string;
  TimeTaken: number;
  CorrectAns: string;
  WrongAns: string;
  OptOrder: string;
  BlankAns: string;
}

interface BrickTableRow {
  Yr: string;
  Passed: number;
  Total: number;
  Percent: number;
  PFullBricks: number;
  PHalfBricks: number;
  PQuarterBricks: number;
  FFullBricks: number;
  FHalfBricks: number;
  FQuarterBricks: number;
}

interface NavReportData {
  header_info: HeaderInfo;
  ss_table: SSTableRow[];
  ssy_table: SSYTableRow[];
  qn_table: QnTableRow[];
  nav_flow_headers: string[];
  nav_flow_data: Record<string, string>[];
  brick_table: BrickTableRow[];
}

// ─── Styles ────────────────────────────────────────────────────────────────────

const S = {
  body: {
    margin: "0px",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: "10pt",
    backgroundColor: "white",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column" as const,
  },
  container: {
    padding: "15px",
    flex: 1,
    display: "flex",
    flexDirection: "column" as const,
    overflow: "hidden",
  },
  sectionTitle: {
    fontFamily: "Arial",
    fontWeight: "bold" as const,
    textAlign: "center" as const,
    backgroundColor: "#C7DDFD",
    color: "#2871D3",
    padding: "6px 8px",
    fontSize: "11pt",
    borderBottom: "1px solid #A0BFFF",
  },
  headerCell: {
    padding: "4px 8px",
    borderRight: "1px solid white",
    borderBottom: "1px solid #A0A0A0",
    textAlign: "center" as const,
    whiteSpace: "nowrap" as const,
    fontWeight: "bold" as const,
    backgroundColor: "#C7DDFD",
    color: "#2859AC",
  },
  row: {
    backgroundColor: "white",
    verticalAlign: "middle" as const,
    color: "black",
    textAlign: "center" as const,
  },
  altRow: {
    backgroundColor: "#F4FAFF",
    verticalAlign: "middle" as const,
    color: "black",
    textAlign: "center" as const,
  },
  cell: {
    padding: "4px 6px",
    borderRight: "1px solid #E0E0E0",
    borderBottom: "1px solid #E0E0E0",
    whiteSpace: "nowrap" as const,
  },
  scrollBox: {
    overflowY: "auto" as const,
    overflowX: "auto" as const,
    border: "1px solid #6699CC",
    backgroundColor: "white",
  },
  btnBlue: {
    color: "white",
    backgroundColor: "#2871D3",
    padding: "6px 14px",
    borderRadius: "4px",
    border: "none",
    fontFamily: "Arial",
    fontSize: "10pt",
    fontWeight: "bold" as const,
    cursor: "pointer",
  },
  btnRed: {
    color: "yellow",
    backgroundColor: "#CC0000",
    padding: "6px 14px",
    borderRadius: "4px",
    border: "none",
    fontFamily: "Arial",
    fontSize: "10pt",
    fontWeight: "bold" as const,
    cursor: "pointer",
  },
};

// ─── Nav-Flow cell colour helper ───────────────────────────────────────────────
// Cell value examples: "2 (P)", "5 (F)", "3 (O)", "QNA", ""
function navCellStyle(value: string, isYrCol: boolean) {
  if (isYrCol) {
    return {
      backgroundColor: "#507CD1",
      color: "#ffffff",
      fontWeight: "bold" as const,
    };
  }
  const v = value.trim();
  if (v === "QNA") return { backgroundColor: "orange", color: "#ffffff" };
  if (v.includes("(P)") || v.includes("(O)"))
    return { backgroundColor: "#ffffff", color: "#000000" };
  if (v.includes("(F)"))
    return { backgroundColor: "#ffffff", color: "#CC0000" };
  return { backgroundColor: "#ffffff", color: "#000000" };
}

// ─── Brick Canvas ──────────────────────────────────────────────────────────────
// Matches the original VB canvas: orange = passed, red = failed, from centre outward
const BrickRowGraphic: React.FC<{
  percent: number;
  rowIndex: number;
  totalRows: number;
}> = ({ percent, rowIndex, totalRows }) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    const W = 400;
    const H = 22;
    const BW = W / 8;
    canvas.width = W;
    canvas.height = H;
    ctx.clearRect(0, 0, W, H);

    const failFrac = (100 - percent) / 100;
    const passFrac = percent / 100;

    // Full orange background (passed)
    ctx.fillStyle = "#F9A31C";
    ctx.fillRect(0, 0, W, H);

    // Red overlay from centre outward (failed portion)
    const center = W / 2;
    const halfFail = (failFrac / 2) * W;
    ctx.fillStyle = "#d70000";
    ctx.fillRect(center, 0, halfFail, H);
    ctx.fillRect(center - halfFail, 0, halfFail, H);

    // White grid lines
    ctx.strokeStyle = "white";
    ctx.lineWidth = 2;
    // Horizontal top line
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.lineTo(W, 0);
    ctx.stroke();

    // Vertical brick dividers (offset alternating rows like real brickwork)
    const rowFromBottom = totalRows - rowIndex;
    let x = rowFromBottom % 2 !== 0 ? 0 : -(BW / 2);
    ctx.beginPath();
    while (x < W) {
      x += BW;
      ctx.moveTo(x, 0);
      ctx.lineTo(x, H);
      ctx.stroke();
    }
  }, [percent, rowIndex, totalRows]);

  return (
    <canvas ref={canvasRef} style={{ display: "block", margin: "0 auto", width: "100%", height: "25px" }} />
  );
};

// ─── Main Component ────────────────────────────────────────────────────────────

const EC_NavReport: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [alertInfo, setAlertInfo] = useState({ show: false, message: "" });
  const [data, setData] = useState<NavReportData | null>(null);
  const [selectedQnRow, setSelectedQnRow] = useState<QnTableRow | null>(null);

  const schoolCode = searchParams.get("StuSch") || "";
  const familyCode = searchParams.get("StuFam") || "";
  const loginId = searchParams.get("StudentId") || "";
  const reportNo = searchParams.get("ReportNo") || "";
  const source = searchParams.get("Source") || "";

  // ── Fetch ──────────────────────────────────────────────────────────────────
  useEffect(() => {
    const fetchReport = async () => {
      if (!schoolCode || !familyCode || !loginId || !reportNo) {
        setAlertInfo({ show: true, message: "Missing required parameters." });
        setLoading(false);
        return;
      }
      try {
        const query = new URLSearchParams({
          SchoolCode: schoolCode,
          FamilyCode: familyCode,
          Login: loginId,
          ReportNo: reportNo,
        });
        const res = await fetch(`${API_BASE_URL}api/get_navigation_report_EC?${query}`);
        const result = await res.json();
        if (result.status === "success") {
          setData(result.data);
        } else {
          setAlertInfo({ show: true, message: result.message || "Failed to load report." });
        }
      } catch {
        setAlertInfo({ show: true, message: "Network error." });
      } finally {
        setLoading(false);
      }
    };
    fetchReport();
  }, [schoolCode, familyCode, loginId, reportNo]);

  // ── View Question ──────────────────────────────────────────────────────────
  // Opens MD_ViewQuestion for the single question selected in the
  // Question Navigation Table.  source=navreport tells MD_ViewQuestion to use
  // the /api/by-report-params/ endpoint (single question, no nav, no filter).
  // The answer fields (CorrectAns, WrongAns, etc.) are forwarded so the
  // iframe bridge can call fn_ShowWrongAns and display the student's answer.
  const handleViewQuestion = () => {
    if (!selectedQnRow) return;
    const hi = data!.header_info;
    const country = hi.Country || hi.MDCurriculum || "";
    const curriculum = hi.MDCurriculum || country;

    const params = new URLSearchParams({
      source: "navreport",               // ← key flag consumed by MD_ViewQuestion
      strand: String(selectedQnRow.Strand),
      substrand: String(selectedQnRow.SubStrand),
      yr: String(selectedQnRow.Yr),
      topic: String(selectedQnRow.Topic),
      qn_no: String(selectedQnRow.QnNo),
      country,
      curriculum,
      // Student's recorded answers — forwarded to /api/by-report-params/
      // so the question iframe can replay and display what the student entered
      correct_ans: selectedQnRow.CorrectAns ?? "",
      wrong_ans: selectedQnRow.WrongAns ?? "",
      opt_order: selectedQnRow.OptOrder ?? "",
      blank_ans: selectedQnRow.BlankAns ?? "",
      // Student context
      StuSch: schoolCode,
      StuFam: familyCode,
      StudentId: loginId,
      ReportNo: reportNo,
    });
    window.open(`/EC_Reports/EC_ViewQuestion?${params.toString()}`, "_blank");
  };

  const handleAnswerSheet = () => {
    const params = new URLSearchParams({
      StuSch: schoolCode,
      StuFam: familyCode,
      StudentId: loginId,
      ReportNo: reportNo,
    });
    window.open(`/EC_Reports/EC_ViewQuestionAnswer?${params.toString()}`, "_blank");
  };

  const handleClose = () => {
    if (source === "StudyHistory") {
      window.history.back();
    } else {
      window.close();
    }
  };

  // ── Guards ─────────────────────────────────────────────────────────────────
  if (loading) return <Loading />;
  if (!data)
    return (
      <>
        {alertInfo.show && (
          <CustomAlert
            message={alertInfo.message}
            onClose={() => setAlertInfo({ ...alertInfo, show: false })}
          />
        )}
      </>
    );

  const hi = data.header_info;
  // console.log("hi", hi)

  // ── Render ─────────────────────────────────────────────────────────────────
  return (
    <div style={S.body}>
      {alertInfo.show && (
        <CustomAlert
          message={alertInfo.message}
          onClose={() => setAlertInfo({ ...alertInfo, show: false })}
        />
      )}
      {/* ── Top popup bar ── */}
      <div style={{
        backgroundImage: `url(${popimg}), url(${popbg})`,
        backgroundRepeat: "no-repeat, no-repeat",
        backgroundPosition: "left center, right center",
        backgroundSize: "30% 100%, 70% 100%",
        height: "16px", color: "white", padding: "7px 0px",
        fontWeight: "bold", fontSize: "12pt", fontFamily: "arial",
        display: "flex", alignItems: "center", justifyContent: "space-between",
      }}>
        <span style={{ marginLeft: "10px" }}>Navigation Report</span>
        <img
          src={popclose}
          alt="close"
          height="30px"
          style={{ cursor: "pointer" }}
          onClick={handleClose}
        />
      </div>

      <div style={S.container}>

        {/* ═══════════ TOP HEADER BAR ════════════════════════════════════════ */}
        <div
          style={{
            backgroundColor: "#DDDDDD",
            padding: "8px 12px",
            marginBottom: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: "8px",
            fontSize: "13pt",
          }}
        >

          <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
            {[
              ["S", hi.SchoolCode],
              ["F", hi.FamilyCode],
              ["L", hi.Name],
              ["Year", hi.Year],
              ["Score", hi.Score],
              ["TestDate", hi.TestDate],
              ["Timetaken", hi.TimeTaken],
            ].map(([label, value]) => (
              <span key={label}>
                <span style={{ color: "#2871D3", fontWeight: "bold" }}>{label}:&nbsp;</span>
                <span style={{ color: "blue", fontWeight: "bold" }}>{value}</span>
              </span>
            ))}
          </div>
          <div style={{ display: "flex", gap: "8px" }}>
            <button
              style={{
                ...S.btnBlue,
                opacity: selectedQnRow ? 1 : 0.55,
                cursor: selectedQnRow ? "pointer" : "not-allowed",
              }}
              onClick={handleViewQuestion}
              disabled={!selectedQnRow}
            >
              VIEW Question
            </button>
            <button style={S.btnRed} onClick={handleAnswerSheet}>
              ANSWER SHEET
            </button>
          </div>
        </div>

        {/* ═══════════ NAVIGATION FLOW TABLE ════════════════════════════════ */}
        <div style={{ ...S.scrollBox, marginBottom: "8px", overflowX: "auto" }}>
          <table
            cellPadding={0}
            cellSpacing={0}
            style={{ borderCollapse: "collapse", width: "100%" }}
          >
            <thead>
              {/* Header row — Yr + SubStrand columns */}
              <tr>
                {data.nav_flow_headers.map((hdr, idx) => (
                  <th
                    key={idx}
                    style={{
                      ...S.headerCell,
                      backgroundColor: "#507CD1",
                      color: "#ffffff",
                      border: "1px solid #3355AA",
                      padding: "4px 8px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {hdr}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.nav_flow_data.map((row, rIdx) => (
                <tr key={rIdx}>
                  {data.nav_flow_headers.map((col, cIdx) => {
                    const val = row[col] ?? "";
                    const isYrCol = col === "Yr";
                    const cs = navCellStyle(val, isYrCol);
                    return (
                      <td
                        key={cIdx}
                        style={{
                          padding: "3px 6px",
                          border: "1px solid #D0D0D0",
                          textAlign: "center",
                          whiteSpace: "nowrap",
                          minWidth: isYrCol ? "30px" : "55px",
                          ...cs,
                        }}
                      >
                        {val || "\u00A0"}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* ═══════════ THREE SIDE-BY-SIDE TABLES ════════════════════════════ */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "22% 26% 50%",
            gap: "18px",
            alignItems: "flex-start",
            marginBottom: "8px",
          }}
        >
          {/* — Strand–SubStrand — */}
          <div style={{ ...S.scrollBox, maxHeight: "320px" }}>
            <table cellPadding={0} cellSpacing={0} style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead style={{ position: "sticky", top: 0, zIndex: 2 }}>
                <tr>
                  <th colSpan={3} style={S.sectionTitle}>
                    Strand - SubStrand table
                  </th>
                </tr>
                <tr>
                  <th style={{ ...S.headerCell, width: "25%" }}>#</th>
                  <th style={{ ...S.headerCell, width: "25%" }}>S</th>
                  <th style={{ ...S.headerCell, borderRight: "none", width: "50%" }}>SS</th>
                </tr>
              </thead>
              <tbody>
                {data.ss_table.map((row, idx) => (
                  <tr key={idx} style={idx % 2 === 0 ? S.altRow : S.row}>
                    <td style={S.cell}>{row.SlNo}</td>
                    <td style={S.cell}>{row.Strand}</td>
                    <td style={{ ...S.cell, borderRight: "none" }}>{row.SubStrand}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* — Strand–SubStrand–Year — */}
          <div style={{ ...S.scrollBox, maxHeight: "320px" }}>
            <table cellPadding={0} cellSpacing={0} style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead style={{ position: "sticky", top: 0, zIndex: 2 }}>
                <tr>
                  <th colSpan={5} style={S.sectionTitle}>
                    Strand - SubStrand - Year Table
                  </th>
                </tr>
                <tr>
                  {["Chrolgy", "S", "SS", "Yr", "Res"].map((h, i) => (
                    <th key={i} style={{ ...S.headerCell, borderRight: i === 4 ? "none" : undefined }}>
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data.ssy_table.map((row, idx) => (
                  <tr key={idx} style={idx % 2 === 0 ? S.altRow : S.row}>
                    <td style={S.cell}>{row.Chronology}</td>
                    <td style={S.cell}>{row.Strand}</td>
                    <td style={S.cell}>{row.SubStrand}</td>
                    <td style={S.cell}>{row.Yr}</td>
                    <td style={{ ...S.cell, borderRight: "none" }}>{row.Result}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* — Question Navigation — */}
          <div style={{ ...S.scrollBox, maxHeight: "320px" }}>
            <table cellPadding={0} cellSpacing={0} style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead style={{ position: "sticky", top: 0, zIndex: 2 }}>
                <tr>
                  <th colSpan={8} style={S.sectionTitle}>
                    Question Navigation Table.
                  </th>
                </tr>
                <tr>
                  {["SlNo", "S", "SS", "Year", "Topic", "QnNo", "Result", "Time in secs"].map(
                    (h, i) => (
                      <th key={i} style={{ ...S.headerCell, borderRight: i === 7 ? "none" : undefined }}>
                        {h}
                      </th>
                    )
                  )}
                </tr>
              </thead>
              <tbody>
                {data.qn_table.map((row, idx) => {
                  const isSelected = selectedQnRow === row;
                  const isFail = row.Result === "F";
                  return (
                    <tr
                      key={idx}
                      style={{
                        backgroundColor: isSelected ? "orange" : idx % 2 === 0 ? "#F4FAFF" : "white",
                        color: isSelected ? "white" : isFail ? "red" : "black",
                        fontWeight: isSelected ? "bold" : "normal",
                        cursor: "pointer",
                        textAlign: "center",
                        verticalAlign: "middle",
                      }}
                      onClick={() => setSelectedQnRow(isSelected ? null : row)}
                    >
                      <td style={S.cell}>{row.Chronology}</td>
                      <td style={S.cell}>{row.Strand}</td>
                      <td style={S.cell}>{row.SubStrand}</td>
                      <td style={S.cell}>{row.Yr}</td>
                      <td style={S.cell}>{row.Topic}</td>
                      <td style={S.cell}>{row.QnNo}</td>
                      <td style={S.cell}>{row.Result}</td>
                      <td style={{ ...S.cell, borderRight: "none" }}>{row.TimeTaken}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>

        {/* ═══════════ BRICK TABLE ═══════════════════════════════════════════ */}
        <div style={{ ...S.scrollBox, marginBottom: "12px", overflow: "visible" }}>
          <table cellPadding={0} cellSpacing={0} style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead style={{ position: "sticky", top: 0, zIndex: 2 }}>
              <tr>
                <th colSpan={10} style={S.sectionTitle}>
                  Brick Table
                </th>
              </tr>
              <tr>
                {[
                  "Yr", "Passed", "Total", "Percent",
                  "PFullBricks", "PHalfBricks", "PQuarterBricks",
                  "FFullBricks", "FHalfBricks", "FQuarterBricks",
                ].map((h, i) => (
                  <th key={i} style={{ ...S.headerCell, borderRight: i === 9 ? "none" : undefined }}>
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.brick_table.map((row, idx) => (
                <tr key={idx} style={idx % 2 === 0 ? S.altRow : S.row}>
                  <td style={S.cell}>{row.Yr}</td>
                  <td style={S.cell}>{row.Passed}</td>
                  <td style={S.cell}>{row.Total}</td>
                  <td style={S.cell}>{row.Percent}%</td>
                  <td style={S.cell}>{row.PFullBricks}</td>
                  <td style={S.cell}>{row.PHalfBricks}</td>
                  <td style={S.cell}>{row.PQuarterBricks}</td>
                  <td style={S.cell}>{row.FFullBricks}</td>
                  <td style={S.cell}>{row.FHalfBricks}</td>
                  <td style={{ ...S.cell, borderRight: "none" }}>{row.FQuarterBricks}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* ═══════════ MASTERY GRAPHIC (Canvas) — below brick table ══════════ */}
        {/* <div style={{ ...S.scrollBox, marginBottom: "12px", overflow: "visible" }}>
          <table cellPadding={0} cellSpacing={0} style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th colSpan={2} style={S.sectionTitle}>
                  Mastery Graphic
                </th>
              </tr>
              <tr>
                <th style={{ ...S.headerCell, width: "60px" }}>Yr</th>
                <th style={{ ...S.headerCell, borderRight: "none" }}>Graphic ({"\u25A9"} orange=pass, red=fail)</th>
              </tr>
            </thead>
            <tbody>
              {data.brick_table.map((row, idx) => (
                <tr key={idx} style={idx % 2 === 0 ? S.altRow : S.row}>
                  <td style={{ ...S.cell, fontWeight: "bold" }}>{row.Yr}</td>
                  <td style={{ ...S.cell, borderRight: "none", padding: 0 }}>
                    <BrickRowGraphic
                      percent={row.Percent}
                      rowIndex={idx}
                      totalRows={data.brick_table.length}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div> */}

        {/* ═══════════ BACK BUTTON ═══════════════════════════════════════════ */}
        {/* <div style={{ display: "flex", justifyContent: "center", marginTop: "4px" }}>
          <button style={S.btnBlue} onClick={() => navigate(-1)}>
            Back
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default EC_NavReport;
